// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700&display=swap.css);"]);
// Module
exports.push([module.id, ".input-image-box[data-v-23b70331]{width:calc(100% - 16px);box-shadow:0 3px 6px rgba(0,0,0,.1607843137254902);background-size:cover;background-position:50%;transition:all .3s;margin:calc(2.5% + 20px) auto calc(2.5% + 20px) auto;padding-bottom:125%;cursor:pointer}.input-image-box.active[data-v-23b70331]{padding-bottom:130%;margin:20px auto 20px auto}", ""]);
// Exports
module.exports = exports;
